import type { components, paths } from "admination-react/api-schema";
import { ApiError, fillPath, getBlob, getJson, sendJson, type WriteIdentity } from "./http";

export type DocumentFamily =
  | "anwesenheitsliste"
  | "bescheinigung"
  | "datenschutz"
  | "ecn"
  | "tb"
  | "vertrag";

export type DocumentSource = NonNullable<
  paths["/documents/{family}"]["post"]["requestBody"]
>["content"]["application/json"];

export type DokumentRead = components["schemas"]["DokumentRead"];

export type DokumentDownload = components["schemas"]["DokumentDownload"];

export function generateDocument(
  family: DocumentFamily,
  source: DocumentSource,
  identity?: WriteIdentity,
): Promise<DokumentRead> {
  return sendJson<DokumentRead>(`/documents/${family}`, "POST", source, undefined, identity);
}

export function documentDownload(dokumentId: string): Promise<DokumentDownload> {
  return getJson<DokumentDownload>(`/documents/${encodeURIComponent(dokumentId)}`);
}

export async function documentBlob(dokumentId: string): Promise<Blob> {
  const { url } = await documentDownload(dokumentId);
  const response = await fetch(url);
  if (!response.ok) throw new Error(`document ${dokumentId}: storage answered ${response.status}`);
  return response.blob();
}

export function blattPdf(dokumentId: string): Promise<Blob> {
  return getBlob(
    fillPath("/vergabe-portal/dokument/{dokument_id}/pdf", { dokument_id: dokumentId })
  );
}

export type BlattKonflikt = components["schemas"]["KonfliktRead"]["code"];

export function blattKonflikt(error: unknown): BlattKonflikt | null {
  if (!(error instanceof ApiError) || error.status !== 409) return null;
  const code = (error.detail as { code?: unknown } | null)?.code;
  return code === "eingeschraenkt" || code === "nicht_ausgefuellt" ? code : null;
}
